import { defineMessages } from "react-intl";
export default defineMessages({
    savedTitle: {
        id: "app.aiDiscoverability.subtopicsBanner.saved.title",
        defaultMessage: "Changes saved — they'll apply to your next report ({shortDate})",
    },
    savedDetail: {
        id: "app.aiDiscoverability.subtopicsBanner.saved.detail",
        defaultMessage: "Today's edits won't show until your next report runs on {longDate}.",
    },
    pendingTitle: {
        id: "app.aiDiscoverability.subtopicsBanner.pending.title",
        defaultMessage: "Subtopic changes are pending — they'll apply on your next report ({shortDate})",
    },
    pendingDetail: {
        id: "app.aiDiscoverability.subtopicsBanner.pending.detail",
        defaultMessage: "This report still uses the previous subtopics. Your updates take effect when the next report runs.",
    },
    runningTitle: {
        id: "app.aiDiscoverability.subtopicsBanner.running.title",
        defaultMessage: "Your report is running now — it's picking up the subtopics you saved",
    },
    runningDetail: {
        id: "app.aiDiscoverability.subtopicsBanner.running.detail",
        defaultMessage: "You're reading the previous run. This page updates as soon as the new one finishes.",
    },
    firstRunTitle: {
        id: "app.aiDiscoverability.subtopicsBanner.firstRun.title",
        defaultMessage: "Generating",
    },
    firstRunDetail: {
        id: "app.aiDiscoverability.subtopicsBanner.firstRun.detail",
        defaultMessage: "This page will populate after the first report runs. Trends will appear once additional assessments are generated.",
    },
    appliedTitle: {
        id: "app.aiDiscoverability.subtopicsBanner.applied.title",
        defaultMessage: "This report reflects your subtopic changes",
    },
    appliedDetail: {
        id: "app.aiDiscoverability.subtopicsBanner.applied.detail",
        defaultMessage: "Run on {runDate} using the subtopics you saved on {shortDate}.",
    },
});
